module.exports = __webpack_public_path__ + "img/bg-1.2ac38a57.png";